export const PERSONALIZED_NOTIFICATION_TEMPLATE_VARIABLES: Record<string, string> = {
	firstName: "Vorname des Benutzers",
	lastName: "Nachname des Benutzers",
};
